module.exports = __webpack_public_path__ + "static/media/HCMM096.6b40c414.jpg";